<p id="countdown-popup">Your session to edit the PDF will be closed in: {{ minsToDisplay }}:{{ secondsToDisplay }}</p>
